import type { SceneHost } from "./SceneHost";
import type { ShapeToolKind } from "@bezpart-board/shared";
import type { BoardToolId } from "./types";

/** Элементы, на которых показывается курсор инструмента (stage + viewport). */
export function boardCursorSurfaces(host: SceneHost): HTMLElement[] {
  const surfaces: HTMLElement[] = [host.stage];
  if (host.hitSurface !== host.stage) surfaces.push(host.hitSurface);
  return surfaces;
}

export function toggleBoardCursorClass(host: SceneHost, className: string, on: boolean): void {
  for (const el of boardCursorSurfaces(host)) {
    el.classList.toggle(className, on);
  }
}

const CLASSIC_CURSOR: Partial<Record<ShapeToolKind, string>> = {
  rect: "is-shape-kind-rect",
  ellipse: "is-shape-kind-ellipse",
  triangle: "is-shape-kind-triangle",
  diamond: "is-shape-kind-diamond",
  star: "is-shape-kind-star",
};

export const SHAPE_KIND_CURSOR_CLASS: Record<string, string> = {
  ...CLASSIC_CURSOR,
};

export function clearShapeKindCursorClasses(host: SceneHost): void {
  for (const el of boardCursorSurfaces(host)) {
    for (const cls of Object.values(CLASSIC_CURSOR)) {
      el.classList.remove(cls);
    }
    el.classList.remove("is-shape-kind-geom");
  }
}

export function syncShapeKindCursorClass(
  host: SceneHost,
  activeTool: BoardToolId,
  kind: ShapeToolKind
): void {
  clearShapeKindCursorClasses(host);
  if (activeTool !== "shape") return;
  const cls = CLASSIC_CURSOR[kind] ?? "is-shape-kind-geom";
  for (const el of boardCursorSurfaces(host)) {
    el.classList.add(cls);
  }
}
